
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/note/templates/input"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='add_note'>\n  <div class='add_note_icon'></div>\n  <div class='label'>Add A Note</div>\n</div>\n<div class='note'>\n  <textarea class='note_comment character_counter input--text' data-charactercounter-max='600' data-charactercounter-remaining='600' maxlength='600' name='note_comment' placeholder='Enter a note...'></textarea>\n</div>\n<div class='remove_note'>\n  <div class='remove_note_icon'></div>\n  <div class='label'>Clear Note</div>\n</div>\n";
},"useData":true});
    }).call(this);
  